import { Page } from "components"
import { Filters, Results } from "./components";
import { useIntl } from "react-intl";
import { LocalizationKey } from "helpers/Enums";


let VisualPriceList = () => {
    let { formatMessage } = useIntl();

    return (
        <Page title={formatMessage({ id: LocalizationKey.VisualPriceList })}>
            <Filters />
            <Results />
        </Page>
    );

}

export default VisualPriceList;